// extracted by mini-css-extract-plugin
module.exports = {"btn":"SwitchImgBtn_btn__2mgqW"};